<template>

</template>

<script>
    export default {
        name: "CrmTicketEdit"
    }
</script>

<style scoped>

</style>